<template>
    <div style="width: 100%;height: 100%;background: #FFFFFF;">
        <div style="float: left">
            <img src="../../../assets/imgs/index/log1.png" style="width: 90px;height: 28px;margin: 16px 0 0 20px;">
        </div>
        <div style="float: left;margin-left: 20px;margin-top: 17px;">
            <div style="height: 21px;font-size: 18px;color: #444444;font-weight:bold;">服务发布</div>
        </div>
    </div>
</template>
<script>
export default {
    components: {

    },

    computed: {

    },
    data () {
        return {

        }
    },
    mounted:function(){

    },
    methods:{


    }
}
</script>